const _0x5ce4 = ["split", "130393sgTRML", "11aoJbgb", "CBC", "19213ktjwXk", "71XJxYgH", "enc", "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678", "join", "charAt", "string", "replace", "114539qvyEmd", "Base64", "ydz_!@#$", "decrypt", "__a", "pad", "parse", "random", "floor", "1dgYTQz", "__b", "encrypt", "DES", "121022pLROmH", "__c", "7752WJIQvK", "Pkcs7", "wydz_!@#", "length", "163808wUJiRg", "947BxUKUW", "toString", "Utf8"];
function _0x29a1(_0x37dde7, _0x1dd404) {
  _0x37dde7 = _0x37dde7 - 0xfd;
  let _0x5ce4b4 = _0x5ce4[_0x37dde7];
  return _0x5ce4b4;
}
(function (_0x5e1fa5, _0x139fde) {
  const _0x2be770 = _0x29a1;
  while (!![]) {
    try {
      const _0xeb3c04 = parseInt(_0x2be770(0x115)) + parseInt(_0x2be770(0x119)) + parseInt(_0x2be770(0x11a)) * parseInt(_0x2be770(0xff)) + parseInt(_0x2be770(0x11f)) * -parseInt(_0x2be770(0xfe)) + parseInt(_0x2be770(0x10f)) * parseInt(_0x2be770(0x11e)) + -parseInt(_0x2be770(0x106)) + parseInt(_0x2be770(0x113));
      if (_0xeb3c04 === _0x139fde) break;
      else _0x5e1fa5["push"](_0x5e1fa5["shift"]());
    } catch (_0x5e06d1) {
      _0x5e1fa5["push"](_0x5e1fa5["shift"]());
    }
  }
})(_0x5ce4, 0x281ea);
import _0x13fbe9, { DES } from "crypto-js";
const desEncrypt = (_0x4f2e98) => {
    const _0x2ef02c = _0x29a1;
    let _0x3a8eef = _0x13fbe9[_0x2ef02c(0x100)][_0x2ef02c(0x11c)][_0x2ef02c(0x10c)]("ydz_!@#$"),
      _0x3e6540 = _0x13fbe9[_0x2ef02c(0x100)][_0x2ef02c(0x11c)]["parse"](_0x2ef02c(0x117)),
      _0x497be6 = _0x13fbe9[_0x2ef02c(0x112)][_0x2ef02c(0x111)](_0x4f2e98, _0x3a8eef, { mode: _0x13fbe9["mode"][_0x2ef02c(0xfd)], padding: _0x13fbe9["pad"][_0x2ef02c(0x116)], iv: _0x3e6540 });
    return _0x497be6[_0x2ef02c(0x11b)]();
  },
  desDecrypt = (_0x33292a) => {
    const _0x19dadb = _0x29a1;
    let _0x57af05 = _0x13fbe9[_0x19dadb(0x100)]["Utf8"][_0x19dadb(0x10c)](_0x19dadb(0x108)),
      _0x5af89a = _0x13fbe9["enc"][_0x19dadb(0x11c)][_0x19dadb(0x10c)](_0x19dadb(0x117));
    if (_0x33292a === "" || _0x33292a === null || _0x33292a === undefined) return "";
    typeof _0x33292a != _0x19dadb(0x104) && (_0x33292a = _0x33292a[_0x19dadb(0x11b)]());
    let _0x4db3f7 = _0x13fbe9[_0x19dadb(0x112)][_0x19dadb(0x109)]({ ciphertext: _0x13fbe9[_0x19dadb(0x100)][_0x19dadb(0x107)]["parse"](_0x33292a) }, _0x57af05, { mode: _0x13fbe9["mode"][_0x19dadb(0xfd)], padding: _0x13fbe9[_0x19dadb(0x10b)][_0x19dadb(0x116)], iv: _0x5af89a });
    return _0x4db3f7[_0x19dadb(0x11b)](_0x13fbe9[_0x19dadb(0x100)][_0x19dadb(0x11c)]);
  },
  resetGetTokenSign = (_0x39f19c, _0x5b28f0) => {
    const _0x516375 = _0x29a1;
    let _0x4961cd = desDecrypt(decryptHandle(decodeURIComponent(_0x39f19c))),
      _0x85db70 = _0x516375(0x101),
      _0xc9f9d1 = _0x85db70[_0x516375(0x118)];
    var _0x58c2f1 = "";
    for (let _0x526772 = 0x0; _0x526772 < 0x6; _0x526772++) {
      _0x58c2f1 += _0x85db70[_0x516375(0x103)](Math[_0x516375(0x10e)](Math[_0x516375(0x10d)]() * _0xc9f9d1));
    }
    let _0x1417d1 = _0x4961cd[_0x516375(0x11d)]("&");
    return (_0x4961cd = (_0x5b28f0 || _0x1417d1[0x0]) + "&" + _0x1417d1[0x1] + "&" + _0x58c2f1), (_0x4961cd = encodeURIComponent(encryptionHandle(desEncrypt(_0x4961cd)))), _0x4961cd;
  },
  encryptionHandle = (_0x472f13) => {
    const _0xcc52a7 = _0x29a1;
    return (_0x472f13 = _0x472f13[_0xcc52a7(0x11d)]("/")[_0xcc52a7(0x102)](_0xcc52a7(0x10a))), (_0x472f13 = _0x472f13[_0xcc52a7(0x11d)]("+")[_0xcc52a7(0x102)](_0xcc52a7(0x110))), (_0x472f13 = _0x472f13[_0xcc52a7(0x11d)]("=")["join"](_0xcc52a7(0x114))), _0x472f13;
  },
  decryptHandle = (_0x3c3021) => {
    const _0x13bd37 = _0x29a1;
    return _0x3c3021[_0x13bd37(0x105)](/__a/g, "/")["replace"](/__b/g, "+")["replace"](/__c/g, "=");
  };
export { desEncrypt, desDecrypt, resetGetTokenSign };
